import AprenderAcordes from './components/AprenderAcordes'

const version = "6.2.1";
const level = "11";

const App = () => {  
  return (
    <div className="flex flex-col justify-end items-center bg-gray-100 fixed top-0 left-0 w-full overflow-hidden touch-none pb-[40px] bg-gray-900 px-10 h-[800px]">
      <div className='absolute top-2 right-3 text-white text-sm'>v{version}</div>
      <div className='absolute top-[20px] left-[30px] text-white text-6xl font-bold flex items-center text-yellow-400'>
        <i className="fa-solid fa-music text-4xl mr-2 mt-2"></i> {level}
      </div>
    
        <AprenderAcordes/>

    </div>
  );
}

export default App;

// Tap:
// https://metronome-online.com/